export const USER_PERMISSION_READ_RECORD = 1;
export const USER_PERMISSION_CREATE_RECORD = 2;
export const USER_PERMISSION_EDIT_RECORD = 4;
export const USER_PERMISSION_DELETE_RECORD = 8;